<i18n>
{
  "fr": {},
  "en": {}
}
</i18n>

<template>
  <section class="hero is-default is-bold">
    <div class="hero-body">
      <maps :fullscreen="true" />
    </div>
  </section>
</template>

<script>
export default {
  name: 'MapsFullscreen',
  components: {
    maps: () => import('@/components/transition/maps/Main.vue')
  }
}
</script>
